import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'পেজ পাওয়া যায়নি',
  title: 'আমরা পেজটি খুঁজে পাইনি',
  body: 'লিংকটি হয়তো পুরোনো, অথবা পেজটি সরিয়ে ফেলা হয়েছে। আপনি কী খুঁজছেন আমাদের বলুন, আমরা খুঁজে দেব।',
  suggestionsTitle: 'আপনি হয়তো এগুলো খুঁজছেন',
  bestMatchTitle: 'আপনি কি এটা খুঁজছিলেন',
  prefillHint: 'আপনি যে ঠিকানাটি খুলতে চেয়েছিলেন, তা থেকে আগেই লিখে রাখা হয়েছে',
  goHome: 'হোম',
  browseAll: 'সব বিভাগ',
  reportBrokenLink: 'অচল লিংক রিপোর্ট করুন',
  noticeTitle: 'পেজটি পাওয়া যাচ্ছে না',
  noticeSearching: 'তার বদলে {query} অনুসন্ধান করা হচ্ছে…',
  noticePrefilled: 'নিচে {query} অনুসন্ধান করুন, অথবা আপনি কী খুঁজছেন আমাদের বলুন।',
  errorTitle: 'কিছু একটা গোলমাল হয়েছে',
  errorBody: 'আমরা এই পেজটি লোড করতে পারিনি। আবার চেষ্টা করুন, অথবা আপনার যা দরকার তা নিচে অনুসন্ধান করুন।',
  retry: 'আবার চেষ্টা করুন',
  streamLostTitle: 'আমরা এই পেজটি শেষ করতে পারিনি',
  streamLostBody: 'পেজটি সেভ হওয়ার আগেই অনুসন্ধান থেমে গেছে। আবার শুরু করুন, আপনার কথাগুলো থেকেই আমরা আবার কাজ শুরু করব।',
  relaunch: 'আবার অনুসন্ধান করুন',
};
